export const CHANGELOG_COVER_PATH = "/api/changelog-cover"

/**
 * Generated cover for a changelog without its own image: logo, release number,
 * date. The language rides in the file name so the URL carries no query string.
 */
export const defaultChangelogCoverUrl = (
	baseUrl: string,
	changelogId: string,
	language?: string | null,
) => {
	const suffix = language && language !== "en" ? `.${language}` : ""
	return `${baseUrl.replace(/\/+$/, "")}${CHANGELOG_COVER_PATH}/${encodeURIComponent(changelogId)}${suffix}.png`
}

/**
 * Cache-buster for the dashboard: the generated cover shows the date and the
 * title, so either changing gives the image a new url.
 */
export function generatedCoverVersion(date: Date | number, title: string) {
	let hash = 0x811c9dc5
	for (const char of title) {
		hash ^= char.codePointAt(0)!
		hash = Math.imul(hash, 0x01000193)
	}
	return `${new Date(date).getTime()}-${(hash >>> 0).toString(36)}`
}

const COVER_FILE =
	/^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\.([A-Za-z]{2}(?:-[A-Za-z]+)?))?\.png$/i

/** Splits `<id>[.<lang>].png` back into its parts; null for anything else. */
export function parseChangelogCoverFile(
	file: string,
): { changelogId: string; language: string | null } | null {
	const match = COVER_FILE.exec(file)
	if (!match) return null
	return { changelogId: match[1]!.toLowerCase(), language: match[2] ?? null }
}

/** Stored as a cover's imageUrl when the author removed the generated cover. */
export const HIDDEN_CHANGELOG_COVER = ""

export const isChangelogCoverHidden = (imageUrl: string | null | undefined) =>
	imageUrl === HIDDEN_CHANGELOG_COVER

/** A translation without its own cover follows the changelog's, removal included. */
export const ownChangelogCover = (
	translationImageUrl: string | null | undefined,
	changelogImageUrl: string | null | undefined,
) => translationImageUrl ?? changelogImageUrl ?? null

/** The changelog's own image, the generated cover, or null once it was removed. */
export const changelogCoverOrDefault = (
	imageUrl: string | null | undefined,
	baseUrl: string,
	changelogId: string,
	language?: string | null,
): string | null =>
	isChangelogCoverHidden(imageUrl)
		? null
		: imageUrl || defaultChangelogCoverUrl(baseUrl, changelogId, language)

/** Near-black cover ground with a trace of the accent; text contrast holds for any accent. */
export function coverGround(hex: string): string {
	const value = hex.replace(/^#/, "")
	const full =
		value.length === 3
			? value
					.split("")
					.map((c) => c + c)
					.join("")
			: value.slice(0, 6)
	const channels = [0, 2, 4].map((i) => parseInt(full.slice(i, i + 2), 16) || 0)
	return `rgb(${channels.map((c) => Math.round(9 + (c - 9) * 0.04)).join(",")})`
}
